import { render, staticRenderFns } from "./RateLimitConfig.vue?vue&type=template&id=1092e6e8&scoped=true"
import script from "./RateLimitConfig.vue?vue&type=script&lang=js"
export * from "./RateLimitConfig.vue?vue&type=script&lang=js"
import style0 from "./RateLimitConfig.vue?vue&type=style&index=0&id=1092e6e8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1092e6e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1092e6e8')) {
      api.createRecord('1092e6e8', component.options)
    } else {
      api.reload('1092e6e8', component.options)
    }
    module.hot.accept("./RateLimitConfig.vue?vue&type=template&id=1092e6e8&scoped=true", function () {
      api.rerender('1092e6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cfg/RateLimitConfig.vue"
export default component.exports